import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { helpers } from "../helpers/helpers";
import Header from "./intro/Header";

const PreviouslyCompletedTest = (props) => {
  const {
    userTest,
    previousUserTest,
    utilisateurSession,
  } = props;
  const isTestChronoCompletedLessThan30DaysAgo = ()=>{
    // When this happens, API return dt_termine with now()
    return (
      props.userTest.automatically_completed === true &&
      props.userTest.automatically_completed_reason ===
      "Timed test was completed less than 30 days ago."
      );
    }
    
    const lang = useSelector((state) => state.lang);
    const getLocaleDateString = () => {
      switch (lang.current_lang) {
        case "fr":
          return "fr-CA";
        case "en":
          return "en-CA";
        case "es":
          return "es-Es";
        default:
          return "en-CA";
      }
    }
    return (
      <div id="previously-completed" className="page">
        <section>
          <Header
            userTest={userTest}
            remote={utilisateurSession.currently_remote}
            userTests={utilisateurSession.userTests}
          />
          <h3>
            <FormattedMessage id="user_test.title.previously-completed" />
          </h3>
          <p>
            <FormattedMessage id="user_test.you-already-completed" />
            {helpers
              .strToDate(previousUserTest.dt_termine)
              .toLocaleDateString(getLocaleDateString(), {
                weekday: "long",
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            .
          </p>
          {isTestChronoCompletedLessThan30DaysAgo() && (
            <div>
              <p>
                <FormattedMessage id="user_test.answer-automatically-copied-from-previous-test" />
              </p>
              <button
                onClick={props.refreshHandler}
                className="btn btn-primary"
              >
                <FormattedMessage id="app.global.button.continue" />
              </button>
            </div>
          )}
          {!isTestChronoCompletedLessThan30DaysAgo() && (
            <div>
              <p>
                <FormattedMessage id="user_test.answer-again" values={
                  { 
                    AnswerAgain: <stong>{props.intl.formatMessage({id: 'user_test.answer-again_answer_again'})}</stong>,
                    UsePrevious: <stong>{props.intl.formatMessage({id: 'user_test.answer-again_use_previous'})}</stong>
                  }
                  } />
              </p>
              <div className="button-bar">
                <button
                  onClick={props.answerAgainHandler}
                  className="btn btn-primary"
                >
                  <FormattedMessage id="previously-completed.label.answer-again" />
                </button>
                <button
                  onClick={props.usePreviousHandler}
                  className="btn btn-default"
                >
                  <FormattedMessage id="previously-completed.label.use-previous-answers" />
                </button>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }

export default injectIntl(PreviouslyCompletedTest);
